import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './Check.styles';

export interface CheckIconProps extends WithStyles<typeof styles> {
  color?: string;
}

const CheckIconComponent: FC<CheckIconProps> = ({ classes, color = '#7E8899' }) => {
  return (
    <SvgIcon
      classes={{ root: classes.root }}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3337 4L6.00033 11.3333L2.66699 8"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.67"
      />
    </SvgIcon>
  );
};

export const CheckIcon = withStyles(styles)(CheckIconComponent);
